import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { HeadingLevel } from '@/components/common/MarkUp';
import { Title } from '@/components/common/Title';
import { TitleWithIcon } from '@/components/common/TitleWithIcon';
import { Stack } from '@/components/layout/Stack';

import type { Heading } from '@/types/shared';

export type IconAndTitleListProps = {
  heading?: Heading;
  list?: Array<{
    _key: string;
    _type: 'icon';
    icon?: any;
    heading: Heading;
    subheading?: string;
  }>;
};

export const IconAndTitleList = ({ heading, list }: IconAndTitleListProps) => {
  if (!heading || !list) {
    return null;
  }

  return (
    <Wrapper>
      <Stack spacing="--space-component-xxl">
        <HeadingLevel>
          <HeadingWrapper>
            <Title heading={heading} size="md" variant="block" />
          </HeadingWrapper>
        </HeadingLevel>
        {list.map((item) => (
          <TitleWithIcon
            iconName={item.icon.name}
            iconVariant="standard"
            variant="block"
            size="sm"
            alignment="left"
            heading={item.heading}
            key={item.subheading}
            subheading={item.subheading}
          />
        ))}
      </Stack>
    </Wrapper>
  );
};

const HeadingWrapper = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: var(--font-weight-semibold);
  }
`;

const Wrapper = styled.div`
  display: flex;
  gap: var(--space-component-xxl);

  ${screen.lg} {
    padding-right: var(--space-block-lg);
  }
`;
